exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sticky-left {\n  position: -webkit-sticky;\n  position: -moz-sticky;\n  position: -o-sticky;\n  position: -ms-sticky;\n  position: sticky;\n  left: 0px;\n  z-index: 1; }\n\n.btn-shift {\n  height: 20px;\n  width: 150px;\n  line-height: 1;\n  padding: 0;\n  margin: 2px; }\n\ntd, th {\n  margin: 0;\n  border-top-width: 0;\n  white-space: nowrap; }\n\n.scroll {\n  overflow-x: scroll;\n  overflow-y: visible;\n  border: 1px solid blue; }\n\n#magic2 {\n  height: 80vh;\n  margin-top: 0; }\n\ntable {\n  table-layout: fixed; }\n\n.thead {\n  white-space: nowrap;\n  overflow-x: hidden; }\n\n.thead div {\n  display: inline-block;\n  width: 150px; }\n\n.thead div div {\n  text-align: center; }\n\n.firstcol {\n  float: left;\n  height: 80vh;\n  overflow-y: hidden; }\n\n.sticky-top {\n  position: -webkit-sticky;\n  position: -moz-sticky;\n  position: -o-sticky;\n  position: -ms-sticky;\n  position: sticky;\n  top: 0px;\n  z-index: 2; }\n\n.sticky-bottom {\n  position: -webkit-sticky;\n  position: -moz-sticky;\n  position: -o-sticky;\n  position: -ms-sticky;\n  position: sticky;\n  bottom: 0px;\n  z-index: 3; }\n\n.thead {\n  background: #FFFFFF;\n  border: 2px solid black; }\n\n.brdr {\n  border: 2px solid black; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shifts-grid/shifts-grid.component.scss
// module id = 423
// module chunks = 1